import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import UpdatePriorityList from './submodules/updatePriorityList';

const PriorityConfiguratorDashboard: React.FC = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updatePriorityList]}
				path={`${path}`}
				configPageName={PAGE_NAMES.dashboard}
				component={UpdatePriorityList}
				exact
			/>
			<Redirect to={`${path}`} />
		</Switch>
	);
};

export default PriorityConfiguratorDashboard;
